import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UsefulHintsService {

  contentSubject: Subject<string> = new Subject();

  openSubject: Subject<void> = new Subject<void>();

  closeSubject: Subject<void> = new Subject<void>();

  private timeout: any;

  constructor() { 
    this.contentSubject.subscribe(() => this.openSubject.next());
    this.openSubject.subscribe(() => {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => this.closeSubject.next(), 10000);
    });
  }

  say(message: string): void {
    this.contentSubject.next(message);
  }
}
